<ll-titulo>Planificaciones</ll-titulo>
<ll-toolnavbar>
    <plan-personales-toolnavbar
        [displayButtons]="'new,search'"
        [urlAll]="'/planificaciones'"
    ></plan-personales-toolnavbar>
</ll-toolnavbar>

<lista-planificaciones [planPersonalTipo]="planPersonalTipo"></lista-planificaciones>
